import { useLazyQuery } from '@apollo/client/react';
import { useCallback } from 'react';

import { FunnelCurrentStateDocument } from '@pflegia/data-access/funnel.generated';
import { FunnelType } from '@pflegia/types/api/funnel/funnel-type';

export const useCheckIfSuperFastTrackNeeded = (jobPositionId?: string) => {
  const [requestCurrentState] = useLazyQuery(FunnelCurrentStateDocument, {});

  return useCallback(async () => {
    if (!jobPositionId) return;
    const { data } = await requestCurrentState({ variables: { funnelType: FunnelType.SuperFastTrack, jobPositionId } });
    return Boolean(data?.state?.key);
  }, [jobPositionId, requestCurrentState]);
};
